import { DiagnosisItem } from "../diagnosis.model";
import { Tooth } from "../../../odontogram/odontogram.model";

export abstract class AbstractCondition {
  static validate(
    item: DiagnosisItem,
    odontogram: Tooth[],
    items: DiagnosisItem[],
  ): boolean {
    return true;
  }

  static apply(odontogram: Tooth[], item: DiagnosisItem): Tooth[] {
    return odontogram;
  }

  static getDescriptionIdentifiers(item: DiagnosisItem): string[] {
    return [item.condition];
  }

  static getDiagnosis360Changes(item: DiagnosisItem): any {
    return null;
  }

  static supports(condition: string): boolean {
    return false;
  }

  static getItemResume(item: DiagnosisItem): any {
    return [];
  }

  static getItemList(item: DiagnosisItem): any {
    return this.getItemResume(item);
  }

  static getTableData(item: DiagnosisItem): any {
    return ["", ""];
  }
}



// WEBPACK FOOTER //
// /app/src/app/core/store/plan-editor/diagnosis/conditions/condition.ts